// extracted by mini-css-extract-plugin
export default {"component":"tKPokXVF","logo":"zRIkz2Yg","children":"Pc9OHXeU","loading":"oay3VyIQ"};